module.exports = __webpack_public_path__ + "static/img/3.ee19638.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/eng/3.png
// module id = jjV4
// module chunks = 0